import React, { useState, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");

  const [code, setCode] = useState("");

  useEffect(() => {
    const savedEmail = sessionStorage.getItem("resetEmail");
    const savedCode = sessionStorage.getItem("resetCode");

    if (!savedEmail || !savedCode) {
      window.location.href = "/membre/forgot-password";
      return;
    }

    setEmail(savedEmail);
  }, []);

  async function submit(e) {
    e.preventDefault();

    setError("");

    if (pass1 !== pass2) {
      return setError(t("resetPassword.errors.mismatch"));
    }

    if (pass1.length < 6) {
      return setError(t("resetPassword.errors.tooShort"));
    }

    const savedEmail = sessionStorage.getItem("resetEmail");
    const savedCode = sessionStorage.getItem("resetCode");

    if (!savedEmail || !savedCode) {
      setError(t("resetPassword.errors.invalidSession"));
      return;
    }

    try {
      const res = await fetch("/api/membre?action=resetPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: savedEmail,
          code: savedCode,
          newPassword: pass1,
        }),
      });

      const data = await res.json();

      if (data.success) {
        sessionStorage.removeItem("resetEmail");
        sessionStorage.removeItem("resetCode");

        window.location.href = "/membre/login";
        return;
      }

      setError(
  data.message || t("resetPassword.errors.resetFailed")
);
    } catch (err) {
      console.error(err);
      setError(t("resetPassword.errors.server"));
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-800">
      <div className="bg-white/95 rounded-3xl shadow-2xl p-8 w-full max-w-md">
        <h1 className="text-2xl font-extrabold text-center text-slate-900">
           {t("resetPassword.title")}
        </h1>

        <form onSubmit={submit} className="space-y-4 mt-6" method="POST">
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              placeholder={t("resetPassword.newPassword")}
              value={pass1}
              onChange={(e) => setPass1(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button
              type="button"
              onClick={() => setShow(!show)}
              className="absolute right-3 top-3"
            >
              {show ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <input
            type={show ? "text" : "password"}
           placeholder={t("resetPassword.confirmPassword")}
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl outline-none focus:ring-2 focus:ring-indigo-500"
          />

          {error && <p className="text-red-600 text-center">{error}</p>}

          <button className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-lg">
            {t("resetPassword.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
